__turbopack_context__.v({
  "active-index": "Ago2Jq_active-index",
  "calculator": "Ago2Jq_calculator",
  "date": "Ago2Jq_date",
  "form": "Ago2Jq_form",
  "headline": "Ago2Jq_headline",
  "page-indexes": "Ago2Jq_page-indexes",
  "placeholder": "Ago2Jq_placeholder",
  "result": "Ago2Jq_result",
  "result-count": "Ago2Jq_result-count",
  "result-count-placeholder": "Ago2Jq_result-count-placeholder",
  "result-list": "Ago2Jq_result-list",
  "result-list-placeholder": "Ago2Jq_result-list-placeholder",
  "result-text": "Ago2Jq_result-text",
  "rich-text": "Ago2Jq_rich-text",
  "rich-text-container": "Ago2Jq_rich-text-container",
  "rich-text-ul": "Ago2Jq_rich-text-ul",
  "search-input": "Ago2Jq_search-input",
  "section": "Ago2Jq_section",
  "start": "Ago2Jq_start",
});
